import { ListResult } from '@shared/api';
import { Api } from '../../Api';
import { ISettingsAccountsDto, TaxFormRequest } from './interfaces';
import { ISettingsAccountsGetQuery } from './query';

export class Accounts {
    private static _basePath = '/Account';

    public static getMethods(parentPath: string) {
        const basePath = `${parentPath}${Accounts._basePath}`;
        return {
            async get(query: ISettingsAccountsGetQuery) {
                const path = '/';
                return await Api.get<ListResult<ISettingsAccountsDto>>({
                    path: `${basePath}${path}`,
                    query,
                });
            },
            async getAccountStatement(request: TaxFormRequest): Promise<any> {
                const response = await Api.post<any>({
                    path: `${basePath}/getAccountStatement`,
                    body: request,
                });
                return response;
            },
            async getTaxForm(request: TaxFormRequest): Promise<any> {
                const response = await Api.post<any>({
                    path: `${basePath}/getTaxForm`,
                    body: request,
                });
                return response;
            },
            async putById(body: ISettingsAccountsDto) {
                const path = '/';
                return await Api.put<void>({
                    path: `${basePath}${path}`,
                    body,
                });
            },
            async getAllAccounts() {
                const path = '/GetAllAccounts';
                return await Api.get<any>({
                    path: `${basePath}${path}`,
                });
            },
        };
    }
}
